import { useQueries } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';

import { getPriceChange } from '~/services/price/price-service';

const QUERY_KEY_PRICE_CHANGE_HISTORY = 'QUERY_KEY_PRICE_CHANGE_HISTORY';

interface UsePriceChangeHistoryListProps {
  tickers: string[];
  from: string;
  to: string;
  reference: string;
  enabled?: boolean;
}

export const usePriceChangeHistoryList = ({
  tickers,
  from,
  to,
  reference,
  enabled = true,
}: UsePriceChangeHistoryListProps) =>
  useQueries({
    queries: tickers.map(ticker => ({
      queryKey: [QUERY_KEY_PRICE_CHANGE_HISTORY, ticker, reference, from, to],
      queryFn: () => getPriceChange({ ticker, reference, from, to }),
      staleTime: getTimeTillEndOfDayMs(),
      enabled,
    })),
    combine: results => ({
      data: results.flatMap(r => (r.data ? [r.data] : [])),
      isLoading: results.some(r => r.isLoading),
      isError: results.every(r => r.isError),
    }),
  });
